const styles = `:host {
  display: block;
  width: 100%;
  font-family: var(--goto-font-family);
}

:host([theme=dark]) {
  color-scheme: dark;
}`; export default styles;